<template>
  <div class="content-wrapper questionnare-wrapper questionnare-question-6">
    <div class="d-flex align-items-start justify-content-center full-height">
      <div class="center full-width">
        <div class="small-text uppercase">Question 4 of 4</div>
        <h3 class="my-4 general-title">What kind of Passoni are you interested in?</h3>
        <div class="question-container my-9 d-flex">
          <button
            class="btn btn-outline-primary questionnaire-prev"
            type="button"
            value="Previous question"
            v-on:click="$emit('go-back')"
          >
            Previous question
            </button>
          <select class="center" name="material" v-model="inputMaterial">
            <option selected disabled>MATERIAL</option>
            <option value="4">TITANIUM</option>
            <option value="7">CARBO-TITANIUM</option>
            <option value="6">STAINLESS STEEL/XCH</option>
            <!-- <option value="2">STEEL</option> -->
            <!-- <option value="5">CARBON</option> -->
            <option value="-1">DON'T KNOW</option>
          </select>
          <select class="center" name="use" v-model="inputUse">
            <option selected disabled>USE</option>
            <option value="2">ROAD</option>
            <option value="3">OFF-ROAD</option>
            <!-- <option value="1">URBAN</option> -->
            <option value="-1">DON'T KNOW</option>
          </select>
          <select class="center" name="brakes" v-model="inputBrakes">
            <option selected disabled>BRAKES</option>
            <option value="1">RIM</option>
            <option value="2">DISK</option>
            <option value="-1">DON'T KNOW</option>
          </select>
          <!-- <select class="center" name="shifting" v-model="inputShifting">
            <option selected disabled>SHIFTING</option>
            <option value="mechanical">MECHANICAL</option>
            <option value="electronic">ELECTRONIC</option>
            <option value="none">DON'T KNOW</option>
          </select> -->
          <button
            class="btn btn-outline-primary questionnaire-next"
            type="button"
            value="Next question"
            v-on:click="localGoNext"
          >
          Next question
          </button>
        </div>
      </div>
      <a
        v-on:click="$emit('skip-questionnaire')"
        class="skip-button small-text uppercase"
        href="#"
        >skip questionnaire</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "questionnare-question-4",
  data() {
    return {
      inputs: ["likely", "when", "visit"],
    };
  },
  props: ["questionAnswers"],
  methods: {
    localGoNext: function () {
      if (this.canGoNext()) {
        this.$emit("go-next");
      }
    },
    canGoNext: function () {
      let err = false;
      let firstFocus = false;
      let requiredField = ['material', 'use', 'brakes'];

      for (let i = 0; i < requiredField.length; i++) {
        let fieldName = requiredField[i];
        let k = this.questionAnswers[fieldName];
        if (typeof k == "undefined" || k == "") {
          if (!firstFocus && document.querySelector("[name=" + fieldName + "]")!=null) {
            document.querySelector("[name=" + fieldName + "]").focus();
          }
          err = true;
          firstFocus = true;
        }
      }
      return !err;
    },
  },
  mounted() {
    document.querySelectorAll("select option:first-child").forEach((item) => {
      item.removeAttribute("selected");
      item.setAttribute("selected", "selected");
    });
  },
  computed: {
    inputMaterial: {
      get() {
        return this.questionAnswers.material;
      },
      set(answer) {
        this.$emit("set-answer", answer, "material");
      },
    },
    inputUse: {
      get() {
        return this.questionAnswers.use;
      },
      set(answer) {
        this.$emit("set-answer", answer, "use");
      },
    },
    inputBrakes: {
      get() {
        return this.questionAnswers.brakes;
      },
      set(answer) {
        this.$emit("set-answer", answer, "brakes");
      },
    },
    inputShifting: {
      get() {
        return this.questionAnswers.shifting;
      },
      set(answer) {
        this.$emit("set-answer", answer, "shifting");
      },
    }
  },
};
</script>

<style lang="scss" scoped>
.questionnare-question-6 {
  input[type="text"],
  input[type="date"],
  select {
    width: 25%;
  }
  .questionnaire-next,
  .questionnaire-prev {
    width: 300px !important;
    padding: 0;
  }
}
</style>